const MAX_U32 = Math.pow(2, 32);

export default MAX_U32;